import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener("turbo:submit-start", this.#increaseProgressBarDelay);
    this.element.addEventListener("turbo:submit-end", this.#onFormSubmit);
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", this.#increaseProgressBarDelay);
    this.element.removeEventListener("turbo:submit-end", this.#onFormSubmit);
  }

  // Private

  #increaseProgressBarDelay = () => {
    this.originalProgressBarDelay = Turbo.config.drive.progressBarDelay;
    Turbo.config.drive.progressBarDelay = 2000;
  }

  #onFormSubmit = (event) => {
    Turbo.config.drive.progressBarDelay = this.originalProgressBarDelay;
    if (event.detail.success) {
      document.addEventListener("turbo:morph", this.#afterMorph);
    }
  }

  #afterMorph = () => {
    setTimeout(() => {
      this.cartDrawerController.open();
    }, 50);
    document.removeEventListener("turbo:morph", this.#afterMorph);
  }

  get cartDrawerController() {
    const dialogEl = document.getElementById("cart-drawer");
    return this.application.getControllerForElementAndIdentifier(dialogEl, "dialog");
  }
}
